<script setup lang="ts">
  import { useForwardProps } from 'radix-vue';
  import { computed } from 'vue';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = defineProps<{ class?: HTMLAttributes['class'] }>();

  const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
  });

  const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <div
    v-bind="forwardedProps"
    :class="
      cn(
        'text-left wrap-break-word h-fit text-foreground overflow-hidden text-ellipsis group-[.item-vertical]:flex group-[.item-vertical]:h-8 group-[.item-vertical]:items-center group-[.item-vertical]:font-medium font-medium',
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>
